module.exports = __webpack_public_path__ + "media/bgm_101.f6294a6d.m4a";